import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import MarketingNav from "@/components/MarketingNav";
import api from "@/lib/api";
import { Check, ArrowRight } from "lucide-react";

export default function Pricing() {
  const [plans, setPlans] = useState([]);
  useEffect(() => {
    api.get("/billing/plans").then((r) => setPlans(r.data)).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <MarketingNav active="pricing" />
      <section className="max-w-7xl mx-auto px-6 py-20">
        <p className="overline text-accent mb-3">Pricing</p>
        <h1 className="text-4xl sm:text-5xl font-light tracking-tighter max-w-2xl">
          Simple pricing that <span className="font-black">scales with you.</span>
        </h1>
        <p className="mt-4 text-foreground/70 max-w-xl">Every plan starts with a 14-day free trial. No card required to begin.</p>

        <div className="grid md:grid-cols-3 gap-px bg-border mt-14 border border-border">
          {plans.map((p, i) => {
            const featured = p.key === "growth";
            return (
              <motion.div
                key={p.key}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.1 }}
                data-testid={`plan-card-${p.key}`}
                className={`p-8 flex flex-col ${featured ? "bg-primary text-primary-foreground" : "bg-card"}`}
              >
                {featured && <span className="overline text-accent mb-3">Most popular</span>}
                <h3 className="text-2xl font-bold">{p.name}</h3>
                <div className="mt-4 flex items-end gap-1">
                  <span className="text-5xl font-black tracking-tighter">£{p.price}</span>
                  <span className={`mb-1.5 text-sm ${featured ? "text-primary-foreground/60" : "text-muted-foreground"}`}>/month</span>
                </div>
                <ul className="mt-8 space-y-3 flex-1">
                  {p.features.map((f) => (
                    <li key={f} className="flex items-start gap-3 text-sm">
                      <Check className={`h-4 w-4 mt-0.5 shrink-0 ${featured ? "text-accent" : "text-accent"}`} />
                      <span className={featured ? "text-primary-foreground/90" : "text-foreground/80"}>{f}</span>
                    </li>
                  ))}
                </ul>
                <Link
                  to="/signup"
                  data-testid={`plan-cta-${p.key}`}
                  className={`mt-8 inline-flex items-center justify-center gap-2 px-6 py-3 font-semibold transition-colors ${
                    featured ? "bg-accent text-accent-foreground hover:bg-primary-foreground hover:text-primary"
                    : "bg-primary text-primary-foreground hover:bg-accent"
                  }`}
                >
                  Start free <ArrowRight className="h-4 w-4" />
                </Link>
              </motion.div>
            );
          })}
        </div>
        <p className="mt-8 text-sm text-muted-foreground">Prices in GBP. Upgrade, downgrade or cancel anytime from your billing settings.</p>
      </section>
    </div>
  );
}
